module.exports = __webpack_public_path__ + "fonts/visuelt-pro-bold.4ddf8240.eot";